import React from 'react';
import PermissionsSettings from '../PermissionsSettings';

/**
 * Component for embedding just the content portion of the permissions settings page in an iframe
 */
const EmbedPermissions: React.FC = () => {
    return (
        <PermissionsSettings hideMenu={true} />
    );
};

export default EmbedPermissions; 